export default "__VITE_ASSET__6BCYuvS$__"